import { render } from "./ProviderAdd.vue?vue&type=template&id=4bbc6889&scoped=true"
import script from "./ProviderAdd.vue?vue&type=script&lang=js"
export * from "./ProviderAdd.vue?vue&type=script&lang=js"

import "./ProviderAdd.vue?vue&type=style&index=0&id=4bbc6889&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bbc6889"]])

export default __exports__